let statusList = {
    new: {
        label: 'New',
        variant: 'primary',
        icon: 'fe-circle'
    },
    // confirmed: {
    //     label: 'Confirmed',
    //     variant: 'info',
    //     icon: 'fe-check-circle'
    // },
    // fitted: {
    //     label: 'Fitted',
    //     variant: 'warning',
    //     icon: 'fe-arrow-down-circle'
    // },
    completed: {
        label: 'Completed',
        variant: 'success',
        icon: 'fe-check-circle'
    },
    cancelled: {
        label: 'Cancelled',
        variant: 'danger',
        icon: 'fe-x-circle'
    }
};
export { statusList };
export default function (status) {
    let statused;

    if (statusList[status]) {
        statused = statusList[status];
    } else {
        statused = {
            label: status
        }
    }

    return statused;
};
